export default import.meta.ROLLDOWN_FILE_URL_pRIxAG2IYbO54rXFvEKnLQ